import {
  postCommonLoginLogout,
  postCommonUserUpdatePassword,
} from '@/services/yizhe-web/yonghuguanli';
import { navLogin } from '@/utils/nav';
import { EditOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import { Divider, Form, Input, Menu, message, Modal, Spin } from 'antd';
import type { ItemType } from 'antd/lib/menu/hooks/useItems';
import moment from 'moment';
import type { MenuInfo } from 'rc-menu/lib/interface';
import React, { useCallback, useState } from 'react';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
export type GlobalHeaderRightProps = {
  menu?: boolean;
};

const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu }) => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const [passwordModalVisible, setPasswordModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [passwordLoading, setPasswordLoading] = useState(false);
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    await postCommonLoginLogout({});
    //   localStorage.removeItem(LOCAL_STORAGE.version);
    //   localStorage.removeItem(LOCAL_STORAGE.redNum);
    localStorage.clear();
    sessionStorage.clear();
    setInitialState((s) => ({ ...s, currentUser: undefined }));
    navLogin();
  };
  const handleUpdatePassword = async (values: { password: string; confirmPassword: string }) => {
    if (values.password !== values.confirmPassword) {
      message.error('两次输入的密码不一致');
      return false;
    }

    try {
      setPasswordLoading(true);
      const { code } = await postCommonUserUpdatePassword({
        password: values.password,
        re_password: values.confirmPassword,
      });
      if (code === '200') {
        message.success('密码修改成功');
        localStorage.clear();
        sessionStorage.clear();
        setInitialState((s) => ({ ...s, currentUser: undefined }));
        navLogin();
        setPasswordModalVisible(false);
        form.resetFields();
      }
    } catch (error) {
      console.error('修改密码失败:', error);
      message.error('修改密码失败，请重试');
    } finally {
      setPasswordLoading(false);
    }
  };
  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event;
      if (key === 'logout') {
        loginOut();
        return;
      }
      if (key === 'userInfo') {
        return;
      }
      if (key === 'editPassword') {
        setPasswordModalVisible(true);
        return;
      }
      history.push(`/account/${key}`);
    },
    [setInitialState],
  );

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser?.user_info?.username) {
    return loading;
  }
  const expire_les_time = Number(sessionStorage.getItem(moment().format('YYYY-MM-DD')));
  const UserInfoTem = (
    <div key="UserInfoTem" className={styles.info}>
      <div className={styles.tit}>
        <span>{currentUser.company_info?.company_name}</span>
        <span className={styles.subtitle}>ID: {currentUser.company_info?.company_id}</span>
        {/* <Button
          type="primary"
          ghost={true}
          onClick={() => {
            history.push('/payment');
          }}
        >
          续费会员
        </Button> */}
      </div>
      <div className={styles.content}>
        {/* <Avatar
          size="small"
          className={styles.avatar}
          src={currentUser.user_info?.avatar}
          alt="avatar"
        /> */}
        <div className={styles.customAvatarBox} style={{ width: 60, height: 60 }}>
          {' '}
          <div className={styles.customAvatarInner} style={{ width: 54, height: 54 }}>
            <div className={styles.customAvatarTxt} style={{ fontSize: 15 }}>
              {currentUser?.auth_roles?.some((role) => role.role_name.includes('管理'))
                ? '管理'
                : '员工'}{' '}
            </div>
          </div>
          {/* <div className={styles.customAvatarInner2}>
            <div className={styles.customAvatarTxt2}>经理</div>
            <div className={styles.customAvatarTxt2}>总理2</div>
          </div> */}
        </div>
        <div>
          <div className={styles.name}>{currentUser.user_info?.username}</div>
          <div className={styles.phone}>手机号码：{currentUser.user_info?.mobile}</div>
          <div className={styles.phone}>
            职位：
            {currentUser?.auth_roles?.map((item: any) => {
              return (
                <span key={item.role_id} className="red-text">
                  {item.role_name} &nbsp;
                </span>
              );
            })}
          </div>
        </div>
      </div>
      <Divider dashed={true} style={{ margin: '10px 0px' }} key="divider-1" />
      <div className={styles.txt}>公司地址：{currentUser.company_info?.company_address}</div>
      <Divider dashed={true} style={{ margin: '10px 0px' }} key="divider-2" />
      <div className={styles.txt}>
        vip剩余<span style={{ color: 'red' }}>{expire_les_time}</span>天
      </div>
      <Divider style={{ margin: '10px 0px' }} key="divider-3" />
    </div>
  );
  const menuItems: ItemType[] = [
    ...(menu
      ? [
          {
            key: 'center',
            icon: <UserOutlined />,
            label: '个人中心',
          },
          {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '个人设置',
          },
          {
            type: 'divider' as const,
          },
        ]
      : []),
    {
      key: 'userInfo',
      label: UserInfoTem,
    },
    {
      key: 'editPassword',
      icon: <EditOutlined />,
      label: '修改密码',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];

  const menuHeaderDropdown = (
    <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick} items={menuItems} />
  );

  return (
    <>
      <HeaderDropdown
        menu={{
          className: styles.menu,
          onClick: onMenuClick,
          items: menuItems,
        }}
      >
        <div className={`${styles.action} ${styles.account}`}>
          {/* <Avatar
            size="small"
            className={styles.avatar}
            src={currentUser?.user_info?.avatar}
            alt="avatar"
          /> */}
          <div className={styles.customAvatarBox}>
            {' '}
            <div className={styles.customAvatarInner}>
              <div className={styles.customAvatarTxt}>
                {' '}
                {currentUser?.auth_roles?.some((role) => role.role_name.includes('管理'))
                  ? '管理'
                  : '员工'}{' '}
              </div>
            </div>
            {/* <div className={styles.customAvatarInner2}>
              <div className={styles.customAvatarTxt2}>经理</div>
              <div className={styles.customAvatarTxt2}>总理2</div>
            </div> */}
          </div>
          <span className={`${styles.name} anticon`}>{currentUser?.user_info?.username}</span>
        </div>
      </HeaderDropdown>

      <Modal
        title="修改密码"
        open={passwordModalVisible}
        onOk={() => form.submit()}
        onCancel={() => {
          setPasswordModalVisible(false);
          form.resetFields();
        }}
        confirmLoading={passwordLoading}
      >
        <Form form={form} onFinish={handleUpdatePassword} layout="vertical">
          <Form.Item
            name="password"
            label="新密码"
            rules={[
              {
                required: true,
                message: '请输入新密码',
              },
              {
                min: 6,
                message: '密码至少6个字符',
              },
            ]}
          >
            <Input.Password placeholder="请输入新密码" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="确认新密码"
            rules={[
              {
                required: true,
                message: '请确认新密码',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="请再次输入新密码" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AvatarDropdown;
